// extracted by mini-css-extract-plugin
module.exports = {"location":"ProfileLocation_location__cRATx","profile-location__title":"ProfileLocation_profile-location__title__RVW2F"};